import { Component } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup,  ReactiveFormsModule,  Validators } from '@angular/forms';
import { MatModule } from '../appModules/mat.module';
import { MatPaginatorModule } from '@angular/material/paginator';


@Component({
  selector: 'app-course-semester-mapping',
  imports:[CommonModule,ReactiveFormsModule,MatModule,MatPaginatorModule],
  templateUrl: './course-semester-mapping.component.html',
  styleUrl: './course-semester-mapping.component.scss'
})
export class CourseSemesterMappingComponent {
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: any = {
   label: ['sno','course_name','Course_code','semester_name','semester_number','createdAt'],
   cols:  ['sno','course_name','Course_code','semester_name','semester_number','createdAt'],

  }
  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  currentPage=0;
 //currentindex=1;
 formGroup: FormGroup;
 isLoading = false;
 semesterNumbers:any=[];
 courseNames:any=[];

 CourseSemesterId: string | null = null;
 
 isCourseSemesterList=false;

 constructor(
   private fb: FormBuilder,
   private api: ApiService,
   private common: CommonService,
 ) {
   this.formGroup = this.fb.group({
     course_id: ['', [Validators.required]],
     semester_id: ['', [Validators.required]],
   });
 }

 ngOnInit(): void {
  
   this.getCourseSemesterList();
 }

 getCourseSemesterList(): void {
   this.isCourseSemesterList=true;
   this.isLoading = true;

   const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
   this.api.get(`settings/getCourseSemesterList?${queryParam.join('&')}`).subscribe({
     next: (response) => {
     
       if (response && response.data && response.data.length > 0) {

         this.dataSource = response.data;
         this.pagination.length = response?.totalCount || 0;
       } else {
         console.log('No CourseSemester found or empty CourseSemester array');
       }
       this.isLoading = false;
     },
     error: (error) => {
       console.error('Error fetching CourseSemester information:', error);
       this.common.notification('Error loading CourseSemester information', true);
       this.isLoading = false;
     }
   });
 }
 
 resetForm(): void {
   this.isCourseSemesterList=false;
   this.formGroup.reset();
  
 }


isEdit=false;
 edit(row:any){
   this.isCourseSemesterList=false;   
   this.CourseSemesterId=row.id;
   this.isEdit=true;
   this.getCourseDropDOwn();
   this.getSemesterDropdown();
   this.formGroup.patchValue({
    course_id: row.course_id,
    semester_id: row.semester_id,
   });
 }
   


 saveCourseSemester(): void {
   this.isCourseSemesterList=false;
   if (this.formGroup.invalid) {
    this.common.notification('Please fill all required information', true);
     return;
   }

   this.isLoading = true; 
   let formData =  this.formGroup.value;
   if (this.CourseSemesterId) {
        
     this.api.put(`settings/updatecourseSem/${this.CourseSemesterId}`, formData).subscribe({
       next: (response) => {
         
         this.common.notification(response.message);
         this.isLoading = false;
       },
       error: (error) => {
         console.error('Error updating settings information. Full error:', error);
         this.isLoading = false;
       }
       
     });
     this.resetForm();
   } else {
    this.api.post(`settings/mapCourseSemester`,formData,true).subscribe({
       next: (response) => {
        if (response.status) {
           this.common.notification(response.message);
           this.isLoading = false;
         }else{
         this.common.notification(response.message);
        }
         this.isLoading = false;
       },
       error: (error) => {
         this.common.notification(`Error saving razorpay: ${error.message || 'Unknown error'}`, true);
         this.isLoading = false;
       }
     });
     this.getCourseSemesterList();
     this.resetForm();
   }
 }
 



 addCourseSemester(){
  
  this.getCourseDropDOwn();
  this.getSemesterDropdown();
   this.resetForm();
   this.isCourseSemesterList=false;
 }
 getCourseDropDOwn(){
  this.api.get(`settings/courseDropDown`).subscribe((resp:any)=>{
    if(resp.status){
      this.courseNames=resp.data;
      
    }else{
      this.common.notification(resp.message);
    }
  });
 }
getSemesterDropdown(){
  this.api.get(`settings/semesterDropDown`).subscribe((resp:any)=>{
    if(resp.status){
      
      this.semesterNumbers=resp.data;
    }else{
      this.common.notification(resp.message);
    }
  });
}

back(){
 this.isEdit=false;
 this.isCourseSemesterList=true;  
 this.resetForm();
 this.CourseSemesterId=null;
 this.getCourseSemesterList();
}

delete(row:any)
{

 const CourseSemesterId=row.id;
 this.api.put(`settings/deleteCourseSemester/${CourseSemesterId}`,'').subscribe((resp:any)=>{
   if(resp.status){
     this.common.notification(resp.message);
   }else{
     this.common.notification("unable to delete");
   }
   this.getCourseSemesterList();

 });
}

pageEvent(e: any) {
  this.isLoading = false;
 
  this.pagination.page = e.pageIndex + 1;
  this.pagination.limit = e.pageSize;
  this.currentPage = e.pageIndex * e.pageSize;
  this.getCourseSemesterList();
}
}
